// extracted by mini-css-extract-plugin
module.exports = {"aplixSignaturePadRoot":"aplixSignaturePadRoot--3797d"};